import React from 'react';
import { HelpDocumentation } from '@ais-ui/help';

export const HelpPage: React.FC = () => {
  return <HelpDocumentation />;
};
